<template>
  <div>
    <el-dialog :visible.sync="show_select" title="链接/事件" width="600px">
      <el-form label-width="100px">
        <el-form-item label="链接类型">
          <!-- <el-radio v-model="forms.type" label="1">页面事件</el-radio> -->
          <!-- <el-radio v-model="forms.type" label="2">
            打开客服
          </el-radio> -->
          <!-- <el-radio v-model="forms.type" label="3">
            地图
          </el-radio> -->
          <el-radio v-model="forms.type" label="4">
            拨打电话
          </el-radio>
        </el-form-item>
        <el-form-item v-if="forms.type==4" label="电话号码">
          <el-input v-model="forms.value" size="small" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show_select = false">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import './selecturl.scss'
export default {
  data() {
    return {
      show_select: true,
      sysPage: [],
      forms: {
        type: '4'
      }
    }
  },
  computed: {
  },
  watch: {
    'show_select': {
      handler(val) {
        if (val) {
          this.get_list()
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    getsysPage(queryString, cb) {
      const arr = queryString ? this.sysPage.filter(val => {
        return (val.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1)
      }) : this.sysPage
      cb(arr)
    },
    save() {
      const forms = JSON.parse(JSON.stringify(this.forms))
      switch (forms.type) {
        case '0':
          forms.title = '链接：'
          if (forms.url) {
            const item = this.sysPage.find(o => {
              return o.value == forms.url
            })
            if (item) {
              forms.title += item.label
            } else {
              forms.title += forms.url
            }
          }
          break
        case '1':
          forms.title = '事件：'
          break
        case '2':
          forms.title = '打开客服'
          forms.url = 'cantact'
          break
        case '3':
          forms.title = '打开地图'
          forms.url = 'map'
          break
        case '4':
          forms.title = '拨打电话：' + forms.value
          forms.url = 'tel://' + forms.value
          break
      }
      this.show_select = false
      console.log(forms)
      this.success(forms)
    }
  }
}
</script>
<style scoped>
.imgbox{
	width: 100%;
	display: flex;
	flex-wrap: wrap;
}
.imgbox .section{
	width: 84px;
	margin-right: 20px;
	margin-bottom: 10px;
	position: relative;
}

.imgbox .section .delImg{
	position: absolute;
	width: 14px;
	height: 14px;
	border-radius: 50%;
	top: -7px;
	right: -7px;
	background: #ef2518;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	cursor: pointer;
	display: none;
	z-index: 10;
}
.imgbox .section:hover .delImg{
	display: flex;
}
.imgbox .section .img{
	width: 84px;
	height: 84px;
	display: flex;
	align-items: center;
	border: 1px solid #eee;
	overflow: hidden;
	justify-content: center;
	position: relative;
}
.imgbox  .section .imgon{
	border: 1px solid #557ce1 !important;
}

</style>
